import styled from 'styled-components'

export const NotificationItemRoot = styled.li`
    list-style: none;
    opacity: 0;
    animation: notificationRowReveal 0.42s ease forwards;

    &:nth-child(2) { animation-delay: 0.04s; }
    &:nth-child(3) { animation-delay: 0.08s; }
    &:nth-child(4) { animation-delay: 0.12s; }
    &:nth-child(5) { animation-delay: 0.16s; }

    @keyframes notificationRowReveal {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
    }

    @media (prefers-reduced-motion: reduce) {
        opacity: 1;
        animation: none;
    }
`;

export const NotificationItemButton = styled.button.attrs({ type: 'button' })`
    width: 100%;
    min-height: 116px;
    padding: 24px 4px;
    border: 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    background: ${({ theme }) => theme.palette.colors.backgroundTransparent};
    color: ${({ theme }) => theme.palette.colors.text};
    display: grid;
    grid-template-columns: 10px minmax(0, 1fr) 32px;
    align-items: center;
    gap: 18px;
    text-align: left;
    cursor: pointer;
    transition: background 0.18s ease, padding 0.18s ease;

    &:hover,
    &:focus-visible {
        padding-left: 12px;
        padding-right: 12px;
        background: ${({ theme }) => theme.palette.colors.surfaceSoft};
    }

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.palette.blue.main};
        outline-offset: -2px;
    }

    @media (max-width: 600px) {
        min-height: 106px;
        padding: 20px 0;
        grid-template-columns: 8px minmax(0, 1fr) 26px;
        gap: 12px;

        &:hover,
        &:focus-visible {
            padding-left: 6px;
            padding-right: 6px;
        }
    }
`;

export const NotificationContent = styled.span`
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 7px;
`;

export const NotificationHeader = styled.span`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 18px;
`;

export const NotificationCategory = styled.span`
    overflow: hidden;
    color: ${({ theme }) => theme.palette.blue.main};
    font-family: Poppins, sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const NotificationTitle = styled.span`
    overflow: hidden;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: 18px;
    font-weight: ${({ $unread }) => $unread ? 700 : 600};
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 600px) {
        font-size: 16px;
    }
`;

export const NotificationTime = styled.time`
    flex: 0 0 auto;
    color: ${({ theme }) => theme.palette.colors.subdued};
    font-family: Lato, sans-serif;
    font-size: 12px;
    line-height: 1.4;
`;

export const NotificationDescription = styled.span`
    overflow: hidden;
    color: ${({ theme }) => theme.palette.colors.muted};
    display: -webkit-box;
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
`;

export const UnreadDot = styled.span`
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ theme, $read }) => $read ? theme.palette.colors.borderStrong : theme.palette.blue.main};
    overflow: hidden;
    text-indent: -9999px;
`;

export const NotificationRowAction = styled.span`
    color: ${({ theme }) => theme.palette.colors.subdued};
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    transition: color 0.18s ease, transform 0.18s ease;

    ${NotificationItemButton}:hover &,
    ${NotificationItemButton}:focus-visible & {
        color: ${({ theme }) => theme.palette.blue.main};
        transform: translateX(3px);
    }
`;
